export const LogoMark = ({ className = "w-7 h-7 text-blue-600" }) => (
  <svg
    className={className}
    viewBox="0 0 34 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="7" width="16" height="10" rx="5" />
    <rect x="16" y="7" width="16" height="10" rx="5" />
  </svg>
);

export const Logo = ({
  className = "",
  markClass = "w-6 h-6 text-blue-600",
  textClass = "text-xl",
  showTagline = false,
  dark = false,
}) => (
  <span className={`inline-flex flex-col ${className}`} data-testid="logo">
    <span className="inline-flex items-center gap-2">
      <LogoMark className={markClass} />
      <span className={`font-bold tracking-tight ${dark ? "text-white" : "text-slate-950"} ${textClass}`}>
        LidLink
      </span>
    </span>
    {showTagline && (
      <span
        className={`mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] ${dark ? "text-slate-500" : "text-slate-400"}`}
      >
        Real People. Real Reach.
      </span>
    )}
  </span>
);
